import {graphql, useFragment} from 'react-relay/hooks'
import {animated, config, useTransition} from 'react-spring'
import {Box} from '@chakra-ui/react'
import {useMachine} from '@xstate/react'

import {ProviderInfoCardGallery_images$key} from './__generated__/ProviderInfoCardGallery_images.graphql'
import {providerInfoCardGalleryMachine} from './providerInfoCardGalleryMachine'
import Image from 'components/Image'

interface ProviderInfoCardGalleryProps {
  images: ProviderInfoCardGallery_images$key
}

const AnimatedBox = animated(Box)

export function ProviderInfoCardGallery(props: ProviderInfoCardGalleryProps) {
  const images = useFragment(
    graphql`
      fragment ProviderInfoCardGallery_images on Image @relay(plural: true) {
        transformedSrc(maxHeight: 300, maxWidth: 640)
      }
    `,
    props.images
  )
  const [state] = useMachine(providerInfoCardGalleryMachine, {
    context: {count: images.length},
  })
  const image = images[state.context.index]
  const transition = useTransition(image, {
    config: config.molasses,
    from: {opacity: 0},
    enter: {opacity: 1},
    leave: {opacity: 0},
  })

  const fragment = transition((style, item) => (
    <AnimatedBox left={0} position="absolute" right={0} style={style} top={0}>
      <Image src={item.transformedSrc} />
    </AnimatedBox>
  ))

  return null

  // return image.fluid ? (
  //   <Box pb={`${100 / image.fluid.aspectRatio}%`} position="relative">
  //     {fragment}
  //   </Box>
  // ) : null
}
